/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_3_QInputs */

const en_serve_faq_3_q = /** @type {(inputs: Serve_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I close the laptop?`)
};

const id_serve_faq_3_q = /** @type {(inputs: Serve_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boleh laptop ditutup?`)
};

/**
* | output |
* | --- |
* | "Can I close the laptop?" |
*
* @param {Serve_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_3_q = /** @type {((inputs?: Serve_Faq_3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_3_q(inputs)
	return en_serve_faq_3_q(inputs)
});